import React from "react"
import PropTypes from "prop-types"

import { combineReducers, createStore, applyMiddleware } from "redux"
import { Provider } from "react-redux"
import thunk from "redux-thunk"
import reducers from "./reducers"

import GetMoreLandingPage from "./get_more_landing_page"

export default class GetMore extends React.Component {
  constructor(props) {
    super(props)
    const combinedReducers = combineReducers(reducers)

    this.store = createStore(
      combinedReducers,
      {
        viewToggle: {
          currentView: props.currentView,
          origin: props.origin,
        },
        getMoreResults: {
          applets: props.getMoreApplets,
          services: props.getMoreServices,
          stories: props.stories,
          diyPath: props.diyPath,
          belowFoldPath: props.belowFoldPath,
        },
        searchResults: {
          searchTerm: props.searchTerm,
          signedIn: props.signedIn,
          applets: props.searchApplets,
          services: props.searchServices,
          recommendedServices: props.recommendedServices,
          shouldLoadMoreApplets: true,
        },
      },
      applyMiddleware(thunk)
    )
  }

  render() {
    return (
      <Provider store={this.store}>
        <GetMoreLandingPage />
      </Provider>
    )
  }
}

GetMore.propTypes = {
  currentView: PropTypes.string,
  searchTerm: PropTypes.string,
  signedIn: PropTypes.bool,
  getMoreApplets: PropTypes.array,
  getMoreServices: PropTypes.array,
  stories: PropTypes.array,
  searchApplets: PropTypes.array,
  searchServices: PropTypes.array,
  recommendedServices: PropTypes.array,
  getMoreToken: PropTypes.string,
  diyPath: PropTypes.string,
  belowFoldPath: PropTypes.string.isRequired,
  origin: PropTypes.string,
}

GetMore.defaultProps = {
  currentView: "discover",
  getMoreApplets: [],
  getMoreServices: [],
  stories: [],
  origin: "",
}
